import script from "./DetalharRegistroFinanceiro.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharRegistroFinanceiro.vue?vue&type=script&setup=true&lang=js"

import "./DetalharRegistroFinanceiro.vue?vue&type=style&index=0&id=c893cff6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c893cff6"]])

export default __exports__